<template>
	<div>
		<el-row :gutter="10" class="mb8">
			<el-col :span="1.5">
				<el-button type="primary" plain icon="el-icon-plus" @click="handleAdd">
					新增</el-button>
			</el-col>
		</el-row>
		<el-table :data="khlist" style="width: 100%">
			<el-table-column prop="mc" label="名称" width="180">
			</el-table-column>
			<el-table-column prop="dh" label="电话" width="180">
			</el-table-column>
			<el-table-column prop="dm" label="代码">
			</el-table-column>
			<el-table-column prop="openId" label="openId">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>


		<el-dialog title="客户资料" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="名称" label-width="120px">
					<el-input v-model="form.mc" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="电话" label-width="120px">
					<el-input v-model="form.dh" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="代码" label-width="120px">
					<el-input v-model="form.dm" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="openId" label-width="120px">
					<el-input v-model="form.openId" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="账套ID" label-width="120px" v-if="admin == 'admin'&&form.ztid===''">
					<el-select v-model="form.ztid" filterable placeholder="请选择">
						<el-option v-for="item in ztList" :key="item.id" :label="item.ztmc" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="ifAdminXg">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import kh from '../api/kehu/index'
	import zt from '../api/zt/index'
	export default {
		name: 'kehu',
		data() {
			return {
				khlist: [],
				dialogFormVisible: false,
				form: {
					dh: "",
					dm: "",
					id: null,
					mc: "",
					openId: "",
					updateDm: "",
					ztid: ""
				},
				ztid: null,
				admin: '',
				ztList: []
			}
		},
		methods: {
			async getkh() {
				let res = await kh.querykh()
				if (res.data.code == 1) {
					this.khlist = res.data.data
				}

			},
			handleDelete(row) {
				this.$confirm('此操作将删除该客户信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let res
					if (this.admin != "admin") {
						res = await kh.delku(row.id)
					} else {
						res = await kh.deleteKhbById(row.id, row.ztid)
					}
					this.isAdmin()
					this.$message({
						type: 'success',
						message: res.data.msg
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			handleEdit(row) {
				this.form = row
				this.dialogFormVisible = true
			},
			async updatekh() {
				this.form.czr = sessionStorage.getItem('fsmm')
				let res = await kh.updatekh(this.form)
				if (res.data.code == 1) {
					if (this.form.id == null) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.dialogFormVisible = false
						this.isAdmin()
					} else {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.dialogFormVisible = false
						this.isAdmin()
					}
				} else {
					this.$message.error(res.data.msg);
				}
			},
			handleAdd() {

				this.form = {
					dh: "",
					dm: "",
					id: null,
					mc: "",
					openId: "",
					updateDm: "Y",
					ztid: ""
				}
				if (this.admin != "admin") {
					this.form.ztid = this.ztid
				}
				this.dialogFormVisible = true
			},
			//管理查询全部
			async queryAllKhbInfo() {
				const {
					data: res
				} = await kh.queryAllKhbInfo({
					ztid: this.ztid
				})
				if (res.code == 1) {
					this.khlist = res.data
				}
			},
			//最高管理员修改/khb/updateAllKhb
			async updateAllKhb() {
				this.dialogFormVisible = false
				this.form.czr = sessionStorage.getItem('fsmm')
				const {
					data: res
				} = await kh.updateAllKhb(this.form)
				if (res.code == 1) {
					this.$message({
						message: res.msg,
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.isAdmin()
			},
			//查询所有账套
			async getZtmsg() {
				const {
					data: res
				} = await zt.getAllzt()
				this.ztList = res.data
			},
			ifAdminXg() {
				if (this.admin != "admin") {
					this.updatekh()
				} else {
					this.updateAllKhb()
				}
			},
			isAdmin() {
				if (this.admin != "admin") {
					this.ztid = JSON.parse(sessionStorage.getItem('ztid'))
					this.getkh()
				} else {
					this.queryAllKhbInfo()
					this.getZtmsg()
				}
			}
		},
		mounted() {
			this.admin = sessionStorage.getItem("dm")
			this.isAdmin()
		}
	}
</script>

<style>
</style>